import { createLoadingSelector } from "./Loading"

import { customerService } from "../../service/customerService.js"
import apiClient from "../../helpers/apiClient"
import { showMessageModal, showMessageModalWithTitle } from "./Modal"
import { push } from "connected-react-router"
import { setToken } from "./SetTokenRes"
import { startSubmit } from "redux-form"

export const GET_OTP = "GET_OTP"
export const GET_OTP_REQUEST = "GET_OTP_REQUEST"
export const GET_OTP_SUCCESS = "GET_OTP_SUCCESS"
export const GET_OTP_FAILURE = "GET_OTP_FAILURE"

export const VALIDATE_OTP = "VALIDATE_OTP"
export const VALIDATE_OTP_REQUEST = "VALIDATE_OTP_REQUEST"
export const VALIDATE_OTP_SUCCESS = "VALIDATE_OTP_SUCCESS"
export const VALIDATE_OTP_FAILURE = "VALIDATE_OTP_FAILURE"

export const VALIDATE_OTP_SIGN_UP = "VALIDATE_OTP"
export const VALIDATE_OTP_SIGN_UP_REQUEST = "VALIDATE_OTP_SIGN_UP_REQUEST"
export const VALIDATE_OTP_SIGN_UP_SUCCESS = "VALIDATE_OTP_SIGN_UP_SUCCESS"
export const VALIDATE_OTP_SIGN_UP_FAILURE = "VALIDATE_OTP_SIGN_UP_FAILURE"

const initialState = {
	mobileNo: "",
	otpCode: "",
	errorMessage: "",
	successMessage: "",
}

const getOTPSelector = createLoadingSelector([GET_OTP])
export const getOTP = (mobileNo, formId, setStep) => (dispatch, getState) => {
	const isFetching = getOTPSelector(getState())
	if (!mobileNo || isFetching) return Promise.resolve()
	return Promise.resolve(dispatch(startSubmit(formId)))
		.then(() => {
			return dispatch({
				types: [GET_OTP_REQUEST, GET_OTP_SUCCESS, GET_OTP_FAILURE],
				callAPI: (config) =>
					apiClient.post("api/Account/SendOTPSMS", mobileNo, config),
				payload: { mobileNo, formId },
			})
		})
		.then((res) => {
			setStep && setStep()
			return res
		})
}

const validateOTPSeclector = createLoadingSelector([VALIDATE_OTP])
export const validateOTP = ({ mobileNo, otpCode }, setStep, formId) => (
	dispatch,
	getState
) => {
	const isFetching = validateOTPSeclector(getState())
	if (!otpCode || isFetching) return Promise.resolve()
	return Promise.resolve(dispatch(startSubmit(formId)))
		.then(() =>
			dispatch({
				types: [VALIDATE_OTP_REQUEST, VALIDATE_OTP_SUCCESS, VALIDATE_OTP_FAILURE],
				callAPI: (config) =>
					apiClient.post(
						"api/Account/ValidateOTP",
						{ mobileNo, otpCode },
						config
					),
				payload: { mobileNo, otpCode, formId },
			})
		)

		.then((res) => {
			return (
				res.response.data &&
				res.response.data.data &&
				res.response.data.data.token &&
				dispatch(setToken(res.response.data.data.token))
			)
		})
		.then(() => setStep())
}
const validateOTPSignUpSeclector = createLoadingSelector([VALIDATE_OTP_SIGN_UP])

export const validateOTPSignUp = ({ mobileNo, otpCode }, formId) => (
	dispatch,
	getState
) => {
	const isFetching = validateOTPSignUpSeclector(getState())
	if (!otpCode || isFetching) return Promise.resolve()
	return Promise.resolve(dispatch(startSubmit(formId)))
		.then(() =>
			dispatch({
				types: [
					VALIDATE_OTP_SIGN_UP_REQUEST,
					VALIDATE_OTP_SIGN_UP_SUCCESS,
					VALIDATE_OTP_SIGN_UP_FAILURE,
				],
				callAPI: (config) =>
					apiClient.post(
						"api/Account/ValidateOTP",
						{ mobileNo, otpCode },
						config
					),
				payload: { mobileNo, otpCode, formId },
			})
		)
		.then(() => {
			const { successMessage } = getState().account

			if (successMessage) {
				dispatch(showMessageModal(successMessage))
			}
			dispatch(push(`/sign-in`))
		})
}

export default function reducer(state = initialState, action) {
	const { payload, errorMessage, successMessage } = action
	switch (action.type) {
		case VALIDATE_OTP_REQUEST:
		case VALIDATE_OTP_SIGN_UP_REQUEST:
		case GET_OTP_REQUEST: {
			return {
				...state,
				data: payload,
				successMessage: "",
				errorMessage: "",
			}
		}
		case VALIDATE_OTP_SIGN_UP_SUCCESS:
		case VALIDATE_OTP_SUCCESS:
		case GET_OTP_SUCCESS: {
			return {
				...state,
				successMessage,
			}
		}

		case VALIDATE_OTP_SIGN_UP_FAILURE:
		case VALIDATE_OTP_FAILURE:
		case GET_OTP_FAILURE: {
			return {
				...state,
				errorMessage,
			}
		}
		default: {
			return state
		}
	}
}



// WEBPACK FOOTER //
// ./src/redux/modules/GetOTP.js